interface IFormatOptions {
  precision: number,
  thousands: string,
  decimal: string
}

class Currency {

  private defaultMoneyFormat:string;
  private placeholderRegex:RegExp;
  private formatOptions:IFormatOptions;
  private moneyFormat:string;

  constructor(defaultMoneyFormat:string) {
    this.defaultMoneyFormat = defaultMoneyFormat;
    this.placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    this.formatOptions = this.getFormatOptions(defaultMoneyFormat);
    this.moneyFormat = this.defaultMoneyFormat;
  }

  public format(cents:number|string, moneyFormat?:string) {
    this.moneyFormat = moneyFormat ? moneyFormat : this.defaultMoneyFormat;
    this.formatOptions = this.getFormatOptions(this.moneyFormat);
    return this.moneyFormat.replace(this.placeholderRegex, this.formatWithDelimiters(cents));
  }

  private getFormatOptions(moneyFormat:string) {
    let precision = 2, thousands = ',', decimal = '.';

    switch(moneyFormat.match(this.placeholderRegex)[1]) {
      case 'amount':
        precision = 2;
        break;
      case 'amount_no_decimals':
        precision = 0;
        break;
      case 'amount_with_comma_separator':
        precision = 2, thousands = '.', decimal = ',';
        break;
      case 'amount_no_decimals_with_comma_separator':
        precision = 0, thousands = '.', decimal = ',';
        break;
    }

    return {
      precision,
      thousands,
      decimal
    }
  }

  public parseFromStringToPrice(price:string) {
    const unit = this.moneyFormat.substring(0, 1);
    return parseFloat(price.replace(unit, '').replace(/,/g, '')) * 100;
  }

  private formatWithDelimiters(cents:number|string) {
    if (typeof cents === 'string') cents = parseInt(cents);
    if (isNaN(cents) || cents == null) return '0';
    const moneyString = (cents / 100.0).toFixed(this.formatOptions.precision);
    const parts = moneyString.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${ this.formatOptions.thousands }`);
    cents = parts[1] ? this.formatOptions.decimal + parts[1] : '';
    return dollars + cents;
  }
}

export default new Currency(window.theme.shop.moneyFormat);

